import { Table } from "antd";
import Column from "antd/es/table/Column";
import { useEffect, useState } from "react";
import { colorConsumeTags } from '../../../../helpers/checkFilters';
import { CardTable } from "../../../../components/Card/CardTable";
import useOverTimeComments from "../hooks/useOverTimeComments";
import OverTimeDownloadButton from "./OverTimeDownloadButton";

const OverTimeComments = ({ year, updateYear, listOfYears, projects, isLoading, quantities }) => {
    const [tab, setTab] = useState("Operaciones-comercial");
    const { columnInformation, comments, updateColumnInformation, updateComments } = useOverTimeComments();

    useEffect(() => {
        updateComments(projects);
    }, [projects, updateComments]);

    useEffect(() => {
        updateColumnInformation(tab);
    }, [tab, updateColumnInformation]);

    return (
        <section className="w-full  h-full ">
            <div className="w-full max-w-[328px]  mx-auto flex flex-col gap-4 lg:flex-row lg:max-w-none lg:justify-center ">
                <div className="h-12 p-1 rounded-[5px]  flex gap-1 border border-solid border-[#CDCDCD] bg-white ">
                    <div
                        className={`w-1/3 h-full rounded-[5px] text-center flex items-center justify-center hover:cursor-pointer transition-all duration-300 ${tab === "Operaciones-comercial" && "bg-[#1677FF] text-white"
                            }`}
                        onClick={() => setTab("Operaciones-comercial")}
                    >
                        Operaciones - Comercial
                    </div>
                    <div
                        className={`w-1/3 h-full rounded-[5px] text-center flex items-center justify-center hover:cursor-pointer transition-all duration-300 ${tab === "Operaciones-areas" && "bg-[#1677FF] text-white"
                            }`}
                        onClick={() => setTab("Operaciones-areas")}
                    >
                        Operaciones - Áreas
                    </div>
                    <div
                        className={`w-1/3 h-full rounded-[5px] text-center flex items-center justify-center hover:cursor-pointer transition-all duration-300 ${tab === "Operaciones" && "bg-[#1677FF] text-white"
                            }`}
                        onClick={() => setTab("Operaciones")}
                    >
                        Operaciones
                    </div>
                </div>
                <OverTimeDownloadButton quantity={quantities} projects={projects} />
            </div>

            <div className="w-full h-full pt-4 ">
                <CardTable title={`Comentarios de proyectos en rojo | ${tab}`} currentValue={year} updateValue={updateYear} listValues={listOfYears}>
                    <Table
                        size="small"
                        loading={isLoading}
                        style={{ fontSize: 12 }}
                        pagination={false}
                        dataSource={comments}
                        width={2000}
                        scroll={{
                            x: 1600,
                            y: 640,
                        }}
                    >
                        <Column
                            width={100}
                            title="Porcentaje"
                            dataIndex="name"
                            key="name"
                            render={(_, record) => {
                                const count = colorConsumeTags(record.percentage);
                                return (
                                    <div
                                        key={record.percentage + Math.random()}
                                        className="percentage-graph"
                                        style={{ fontSize: 7, width: "100%", display: "flex", justifyContent: "center", alignContent: "center" }}
                                    >
                                        <span style={{ fontSize: 10 }}>{count}</span>
                                    </div>
                                );
                            }}
                        />
                        <Column width={200} title="Proyecto" dataIndex="name" key="name" />
                        {columnInformation.rows}
                    </Table>
                </CardTable>
            </div>
        </section>
    );
};

export default OverTimeComments;